module.exports = __webpack_public_path__ + "static/lucaswork5-6e571faacd7cb54c812ab619fa4faee7.jpg";